import React, { useState, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "react-times/css/classic/default.css";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import FileUpload from "components/sales/fileUpload/fileUpload";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import CardSection from "components/sales/cardSection/cardSection";

const Tutorial = ({
  saveTutorialData,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const { id } = useParams();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedQuestionType, setselectedQuestionType] = useState("");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const history = useHistory();
  const [addedCards, setAddedCards] = useState([
    {
      attachment: null,
      selectedQuestionType: "",
    },
  ]);
  const [newCardIndices, setNewCardIndices] = useState([]);

  const handleQuestionChange = (value) => {
    setQuestion(value);
  };

  const handleTextAreaChange = (e) => {
    setAnswer(e.target.value);
  };

  const handleSubmit = async () => {
    const isAnyCardMissingAttachment = addedCards.some(
      (card) => !card.attachment
    );

    const isMainFieldsFilled = question && answer;

    if (isAnyCardMissingAttachment || !isMainFieldsFilled) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const dataToSend = {
      question: question,
      answer: answer,
      details: addedCards,
    };

    try {
      setIsLoading(true);
      const res = await saveTutorialData(dataToSend);
      setIsLoading(false);

      if (res === true) {
        toast.success("Question added successfully.");
        setTimeout(() => history.push(`${baseUrl}/tutorial-listing`), 1000);
      } else {
        toast.error("Failed to add questions.");
        setTimeout(() => history.push(`${baseUrl}/tutorial-listing`), 1000);
      }
    } catch (error) {
      console.error("Error:", error);
    }

    setAddedCards([]);
    setNewCardIndices([]);
  };

  const handleAddCard = () => {
    setAddedCards([...addedCards, { selectedQuestionType: "" }]);
    setNewCardIndices([...newCardIndices, newCardIndices.length]);
  };

  const handleRemoveCard = (index) => {
    setNewCardIndices(newCardIndices.filter((i) => i !== index));
    setAddedCards(addedCards.filter((card, i) => i !== index));
  };

  const updateCardState = (index, key, value) => {
    setAddedCards((prevCards) =>
      prevCards.map((card, i) =>
        i === index ? { ...card, [key]: value } : card
      )
    );
  };

  return (
    <Layout
      title={localization.tutorial}
      isGoback={true}
      isLoading={isLoading}
      linkUrl={`${baseUrl}/tutorial-listing`}
    >
      <CardSection title={localization.tutorialQuestion}>
        <div className="details-listing">
          <ConstantInput
            label={localization.question}
            errorMsg={localization.requiredCompanyName}
            type="text"
            required
            isStarRequired={true}
            value={question}
            handleChange={handleQuestionChange}
          />
          <TextAreaInput
            type="text"
            rows={4}
            label={localization.answer}
            value={answer}
            required
            isStarRequired={true}
            inputValue={answer}
            errorMsg={localization.isRequired}
            handleChange={handleTextAreaChange}
            fwidth={true}
            style={{ maxWidth: "96%" }}
          />

          {addedCards.map((card, index) => (
            <div className="row">
              <div key={index} className="card" style={{ marginTop: "20px" }}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-4">
                      <DropDownInput
                        name={`questionType_${index}`}
                        data={[
                          { name: "PDF", id: "PDF" },
                          { name: "Video", id: "Video" },
                          { name: "Image", id: "Image" },
                        ]}
                        label={localization.questionType}
                        required={true}
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        value={card.selectedQuestionType}
                        getIdValue={(val) =>
                          updateCardState(index, "selectedQuestionType", val.id)
                        }
                      />
                    </div>
                    {card.selectedQuestionType === "Video" && (
                      <div className="col-3">
                        <FileUpload
                          id={`attachment_${index}`}
                          accept=".mp4,.webm,.mkv"
                          documentUploadUrl={documentUploadUrlPublic}
                          documentUrlData={documentUrlDataPublic}
                          onChange={(val) =>
                            updateCardState(index, "attachment", val)
                          }
                        >
                          <span className="btn btn-transparent">
                            {localization.uploadAttachment}
                          </span>
                        </FileUpload>
                      </div>
                    )}

                    {card.selectedQuestionType === "PDF" && (
                      <div className="col-3">
                        <FileUpload
                          id={`attachment_${index}`}
                          accept=".pdf"
                          documentUploadUrl={documentUploadUrlPublic}
                          isStarRequired={true}
                          documentUrlData={documentUrlDataPublic}
                          onChange={(val) =>
                            updateCardState(index, "attachment", val)
                          }
                        >
                          <span className="btn btn-transparent">
                            {localization.uploadAttachment}
                          </span>
                        </FileUpload>
                      </div>
                    )}

                    {card.selectedQuestionType === "Image" && (
                      <div className="col-3">
                        <FileUpload
                          id={`attachment_${index}`}
                          accept=".png,.jpg,.jpeg"
                          documentUploadUrl={documentUploadUrlPublic}
                          isStarRequired={true}
                          documentUrlData={documentUrlDataPublic}
                          onChange={(val) =>
                            updateCardState(index, "attachment", val)
                          }
                        >
                          <span className="btn btn-transparent">
                            {localization.uploadAttachment}
                          </span>
                        </FileUpload>
                      </div>
                    )}
                    {index !== 0 && (
                      <div className="col-1">
                        <button
                          className="btn btn-sm btn-danger"
                          // style={{ marginLeft: "85%" }}
                          onClick={() => handleRemoveCard(index)}
                        >
                          Remove
                        </button>
                      </div>
                    )}
                    {index + 1 == addedCards.length && (
                      <div className="col-3">
                        <button
                          className="btn btn-sm btn-success"
                          onClick={handleAddCard}
                        >
                          Add
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div
            style={{ marginBottom: "30px", marginTop: "5%" }}
            className="col-md-12 col-sm-5"
          >
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </CardSection>
    </Layout>
  );
};

export default Tutorial;
